import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";

import { environment } from "../../../../environments/environment";
import { NotificationService } from "../../_services/notification.service";
import * as RegionActions from "./region.actions";
import { Region } from "./region.model";
import { RegionService } from "./region.service";

@Injectable()
export class RegionEffects {
  private actions$ = inject(Actions);
  private regionService = inject(RegionService);
  private notificationService = inject(NotificationService);

  loadRegions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionActions.loadRegions),
      mergeMap(() => {
        return this.regionService.getRegions().pipe(
          map(regionsResponse => {
            let regions = regionsResponse.regions;

            // In local development mode, add local region to see both dev and local data
            if (!environment.production) {
              const localRegion: Region = {
                id: "local",
                name: "Local",
                url: environment.developmentUrl.slice(0, -1),
                code: "LOCAL",
                isActive: true,
              };
              regions = [localRegion, ...regions];
            }

            return RegionActions.loadRegionsSuccess({ regions });
          }),
          catchError(error => {
            this.notificationService.showError("Failed to load regions");
            return of(
              RegionActions.loadRegionsFailure({
                error: error.message || "Unknown error occurred",
              })
            );
          })
        );
      })
    )
  );
}
